import { render } from "./BFaceFinishButton.vue?vue&type=template&id=fe087b9c&scoped=true"
import script from "./BFaceFinishButton.vue?vue&type=script&lang=js"
export * from "./BFaceFinishButton.vue?vue&type=script&lang=js"

import "./BFaceFinishButton.vue?vue&type=style&index=0&id=fe087b9c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-fe087b9c"

export default script